<div class="login-page">
  <div class="login-shell">
    <div class="login-card">
      <div class="login-brand">
        <a href="/" class="login-logo-link" aria-label="Scan My Invoice home">
          <img [src]="brand.logo" alt="Scan My Invoice" />
        </a>
      </div>

      <div class="login-head">
        <h1>Sign in</h1>
        <p>Access your Scan My Invoice portal</p>
      </div>

      <form class="login-form" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <div class="login-alert" *ngIf="errorMsg" role="alert">{{ errorMsg }}</div>

        <div class="login-field">
          <label for="login-email">Email address</label>
          <div class="login-input-wrap" [class.invalid]="loginForm.controls['email'].invalid && loginForm.controls['email'].touched">
            <i-feather name="mail" aria-hidden="true"></i-feather>
            <input
              id="login-email"
              type="email"
              formControlName="email"
              placeholder="name@company.com"
              autocomplete="username"
              (input)="errorMsg = null">
          </div>
          <span class="login-error" *ngIf="loginForm.controls['email'].invalid && loginForm.controls['email'].touched">
            Please enter a valid email address
          </span>
        </div>

        <div class="login-field">
          <label for="login-password">Password</label>
          <div class="login-input-wrap" [class.invalid]="loginForm.controls['password'].invalid && loginForm.controls['password'].touched">
            <i-feather name="key" aria-hidden="true"></i-feather>
            <input
              id="login-password"
              [type]="showPassword ? 'text' : 'password'"
              formControlName="password"
              placeholder="Enter your password"
              autocomplete="current-password"
              (input)="errorMsg = null">
            <button type="button" class="login-toggle" tabindex="-1" (click)="showPassword = !showPassword" [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'">
              <i-feather [name]="showPassword ? 'eye-off' : 'eye'"></i-feather>
            </button>
          </div>
          <span class="login-error" *ngIf="loginForm.controls['password'].invalid && loginForm.controls['password'].touched">
            Please enter your password
          </span>
        </div>

        <label class="login-remember">
          <input type="checkbox" formControlName="remeberpassword" />
          <span>Remember me on this device</span>
        </label>

        <button type="submit" class="login-submit">Sign in</button>
      </form>
    </div>

    <p class="login-foot">Copyright © {{ basicService.current_year }} ScanMyInvoice. All rights reserved.</p>
  </div>
</div>

<div class="login-pwd-overlay" *ngIf="pwdOpen">
  <div class="login-pwd-panel" role="dialog" aria-modal="true" aria-labelledby="forgotTitle" (click)="$event.stopPropagation()">
    <div class="login-pwd-head">
      <div>
        <h3 id="forgotTitle">Forgot password</h3>
        <p class="login-pwd-sub">Enter your registered email and we will send reset instructions</p>
      </div>
      <button type="button" class="login-pwd-close" aria-label="Close" [disabled]="showprogress" (click)="forgotStatus === 'success' ? finishForgotPassword() : closeForgotModal()">×</button>
    </div>

    <div class="login-pwd-result" *ngIf="forgotStatus === 'success'; else forgotFormBlock">
      <div class="login-pwd-result-icon">✓</div>
      <h4 class="login-pwd-result-title">Reset link sent</h4>
      <p class="login-pwd-result-text">{{ forgotMessage }}</p>
      <div class="login-pwd-actions">
        <button type="button" class="login-btn-primary" (click)="finishForgotPassword()">Done</button>
      </div>
    </div>

    <ng-template #forgotFormBlock>
      <div class="login-alert" *ngIf="forgotStatus === 'error' && forgotMessage" role="alert">
        {{ forgotMessage }}
      </div>

      <form [formGroup]="passwordForm" (ngSubmit)="onSubmitPassword()">
      <div class="login-field">
        <label for="forgot-email">Email address</label>
        <div class="login-input-wrap">
          <i-feather name="mail" aria-hidden="true"></i-feather>
          <input id="forgot-email" type="email" formControlName="emailid" placeholder="name@company.com" autocomplete="email" (input)="clearForgotFeedback()">
        </div>
        <span class="login-error" *ngIf="passwordForm.controls['emailid'].invalid && passwordForm.controls['emailid'].touched">
          Please enter your email address
        </span>
      </div>

      <div class="login-pwd-actions">
        <button type="button" class="login-btn-ghost" [disabled]="showprogress" (click)="closeForgotModal()">Cancel</button>
        <button type="submit" class="login-btn-primary" [disabled]="showprogress || passwordForm.invalid">
          {{ showprogress ? 'Sending…' : 'Reset password' }}
        </button>
      </div>
    </form>
    </ng-template>
  </div>
</div>
